module.exports = __webpack_public_path__ + "images/category_lp/common/icon-voice-woman-30@2x_c3ec1556e69d3ec16ffd597b25c9186b.png";